document.addEventListener("DOMContentLoaded", function () {

    const waitForElements = (selector, callback, interval = 500) => {
        const elements = document.querySelectorAll(selector);
        if (elements.length) return callback(elements);
        setTimeout(() => waitForElements(selector, callback, interval), interval);
    };

    const getNumberFromString = (text) => {
        const match = text.match(/[\d.]+/);
        return match ? parseFloat(match[0]) : null;
    };

    const getReviewsText = (str) => {
        const match = str.match(/(\d+)\s*reviews/i);
        return match ? `${match[1]} reviews` : null;
    };

    const addTextToElements = (elements, text) => {
        elements.forEach(el => {
            const p = document.createElement("p");
            p.textContent = text;
            el.insertBefore(p, el.firstChild);
        });
    };

    const addTextToElementsForOverAll = (elements, text) => {
        elements.forEach(el => {
            const p = document.createElement("p");
            p.textContent = text;
            el.appendChild(p);
        });
    };

    const addTextInsideElement = (elements, startText, endText) => {
        elements.forEach(el => {
            el.insertAdjacentText("afterbegin", startText);
            el.insertAdjacentText("beforeend", endText);
        });
    };

    const createAverageCustomerSection = (val) => {
        const newSection = document.createElement("section");
        if (val) {
            newSection.className = "average-customer-section average-bottom";
        } else {
            newSection.className = "average-customer-section";
        }
        newSection.innerHTML = `
        <p class="average-customer-section-header">Average Customer Ratings</p>
        <div class="average-customer-section-row">
            <div class="average-customer-section-row">
                <div class="quality-of-product">
                    <p>quality of product</p>
                    <div class="average-customer-section-flex">
                        <div class="quality-of-product-row">
                            <div class="quality-of-product-back"></div>
                            <div class="quality-of-product-column">
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                            </div>
                        </div>
                        <p>4.5</p>
                    </div>
                </div>

                <div class="value-of-product">
                    <p>value of product</p>
                    <div class="average-customer-section-flex">
                        <div class="value-of-product-row">
                            <div class="value-of-product-back"></div>
                            <div class="quality-of-product-column">
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                            </div>
                        </div>
                        <p>4.2</p>
                    </div>
                </div>

                <div class="comfort">
                    <p>comfort</p>
                    <div class="average-customer-section-flex">
                        <div class="comfort-row">
                            <div class="comfort-back"></div>
                            <div class="quality-of-product-column">
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                                <div class="border-cloumn"></div>
                            </div>
                        </div>
                        <p>4.2</p>
                    </div>
                </div>

                <div class="fit">
                    <p>fit</p>
                    <div class="fit-row">
                        <div class="fit-back"></div>
                        <div class="fit-column">
                            <div class="fit-column-group"></div>
                            <div class="fit-column-group"></div>
                            <div class="fit-column-group"></div>
                            <div class="fit-column-group"></div>
                        </div>
                        <div class="fit-between">
                            <p>runs small</p>
                            <p>runs large</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
        return newSection;
    };


    // 0. Remove judge.me style And add background

    document.getElementById("judgeme_product_reviews").style = "";
    const sectionBackground = document.getElementById("judgeme_product_reviews");
    sectionBackground.parentNode.parentNode.parentNode.style.backgroundColor = "#fafafa"

    // 1. Update star ratings text

    const reviewHeaderSelector = '#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-histogram .jdgm-histogram__star';
    document.querySelectorAll(reviewHeaderSelector).forEach(el => {
        const rating = parseInt(el.parentElement.getAttribute('data-rating'), 10);
        el.textContent = `${rating} star${rating !== 1 ? "s" : ""}`;
    });

    // 2. Create overall rating section

    const reviewStarsNodes = document.querySelectorAll('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-rev-widg__summary .jdgm-rev-widg__summary-stars');
    const reviewTextNodes = document.querySelectorAll('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-rev-widg__summary .jdgm-rev-widg__summary-text');

    if (reviewStarsNodes.length && reviewTextNodes.length) {
        const ratingValue = getNumberFromString(reviewStarsNodes[0].getAttribute("aria-label"));

        const starsContainer = document.createElement("div");
        const textContainer = document.createElement("div");
        const reviewFlexWrapper = document.createElement("div");
        const overallWrapper = document.createElement("div");
        const ratingNumberDiv = document.createElement("div");

        ratingNumberDiv.textContent = ratingValue;
        starsContainer.className = "review-stars-container";
        textContainer.className = "review-text-container";
        reviewFlexWrapper.className = "review-flex-wrapper";
        overallWrapper.className = "review-overall-rating";
        ratingNumberDiv.className = "review-rating-number";

        textContainer.textContent = getReviewsText(reviewTextNodes[0].innerText);

        Array.from(reviewStarsNodes[0].children).forEach(star => starsContainer.appendChild(star));

        reviewFlexWrapper.appendChild(starsContainer);
        reviewFlexWrapper.appendChild(textContainer);
        overallWrapper.appendChild(ratingNumberDiv);
        overallWrapper.appendChild(reviewFlexWrapper);

        document.querySelector('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-rev-widg__summary')
            .appendChild(overallWrapper);
    }

    // 3. Add extra text

    function addTextWhenReady() {
        const stars = document.querySelectorAll(".jdgm-widget-actions-wrapper");

        if (stars.length > 0) {
            stars.forEach(el => {
                if (!el.dataset.textAdded) {
                    const topP = document.createElement("p");
                    topP.textContent = "Review this Product";

                    const bottomP = document.createElement("p");
                    bottomP.textContent = "Adding a review will require a valid email for verification";

                    el.insertBefore(topP, el.firstChild);
                    el.appendChild(bottomP);

                    el.dataset.textAdded = "true";
                }
            });
            return;
        }

        setTimeout(addTextWhenReady, 500);
    }

    addTextWhenReady();

    addTextToElements(document.querySelectorAll('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-histogram'), "Select a row below to filter reviews.");
    addTextToElements(document.querySelectorAll('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-histogram'), "Rating Snapshot");
    addTextToElements(document.querySelectorAll('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-rev-widg__summary'), "Overall Rating");
    addTextToElementsForOverAll(document.querySelectorAll('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header .jdgm-rev-widg__summary'), "16 out of 19 (84%) reviewers recommend this product");

    // 4. Insert average customer section

    function waitForSelector(selector, { timeout = 8000, resolveOnTimeout = false } = {}) {
        return new Promise((resolve) => {
            const found = document.querySelectorAll(selector);
            if (found.length > 0) {
                return resolve(found);
            }

            const observer = new MutationObserver(() => {
                const current = document.querySelectorAll(selector);
                if (current.length > 0) {
                    observer.disconnect();
                    resolve(current);
                }
            });

            observer.observe(document.documentElement, { childList: true, subtree: true });

            if (timeout > 0) {
                setTimeout(() => {
                    observer.disconnect();
                    resolve(resolveOnTimeout ? document.querySelectorAll(selector) : document.querySelectorAll(null));
                }, timeout);
            }
        });
    }

    async function initAverageCustomerSection() {
        const mediaSelector = ".jdgm-legacy-widget-content .jdgm-row-media";
        const starsSelector = ".jdgm-legacy-widget-content .jdgm-row-stars";

        const mediaSection = await waitForSelector(mediaSelector, { timeout: 6000, resolveOnTimeout: true });

        if (mediaSection.length > 0) {
            const titles = document.querySelectorAll(".jdgm-gallery-title");
            titles.forEach(t => { t.textContent = "Customer photos & videos"; });

            mediaSection[0].insertAdjacentElement("beforebegin", createAverageCustomerSection(false));
            return;
        }

        const starsSection = await waitForSelector(starsSelector, { timeout: 6000, resolveOnTimeout: true });
        if (starsSection.length > 0) {
            starsSection[0].insertAdjacentElement("afterend", createAverageCustomerSection(true));
        }
    }

    initAverageCustomerSection();

    // 5. Process individual reviews

    const people_review = document.querySelectorAll(".jdgm-rev-widg__body .jdgm-rev-widg__reviews .jdgm-rev");
    const show_data = Array.from(people_review).map(item => ({
        stars: item.querySelector(".jdgm-rev__rating")?.getAttribute("data-score") || 5,
        text: item.querySelector(".jdgm-rev__body p")?.innerText || "",
        size: item.querySelectorAll(".jdgm-rev__cf-ans__value")[0]?.innerText || "",
        fit: item.querySelectorAll(".jdgm-rev__cf-ans__value")[1]?.innerText || "",
        author: item.querySelector(".jdgm-rev__author-wrapper span")?.innerText || ""
    }));

    const targetDivs = document.querySelectorAll('#judgeme_product_reviews .jdgm-legacy-widget-content .jdgm-rev-widg__header');
    const review_final_div = document.createElement("div");
    review_final_div.className = "review-final-section";

    show_data.forEach((item, index) => {
        const card = document.createElement("div");
        card.className = "review-final-card";

        if (index < 2) {
            card.innerHTML = `
            <div class="review-final-star-text">
                <div class="review-final-star">
                ${'<span class="jdgm-star jdgm--on"></span>'.repeat(item.stars)}
                ${'<span class="jdgm-star jdgm--off"></span>'.repeat(5 - item.stars)}
                </div>
                <div class="review-text">${item.text}</div>
            </div>
            <div class="review-stretch">
                <div class="review-size-fit">
                <div class="review-size"><p>size</p><p>${item.size}</p></div>
                <div class="review-fit"><p>Comfort</p><p>${item.fit}</p></div>
                </div>
                <div class="review-tenny">${item.author}</div>
            </div>
            `;
            review_final_div.appendChild(card);
        }
    });

    targetDivs.forEach(div => div.appendChild(review_final_div.cloneNode(true)));

    //6. Add Swiper Slider Code to image and video section

    (function () {

        const SWIPER_CSS = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        const SWIPER_JS = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";

        function ensureSwiperLoaded() {
            return new Promise((resolve, reject) => {
                if (window.Swiper) {
                    return resolve();
                }
                if (!document.querySelector('link[data-swiper-css]')) {
                    const link = document.createElement("link");
                    link.rel = "stylesheet";
                    link.href = SWIPER_CSS;
                    link.setAttribute("data-swiper-css", "1");
                    document.head.appendChild(link);
                }
                if (!document.querySelector('script[data-swiper-js]')) {
                    const s = document.createElement("script");
                    s.src = SWIPER_JS;
                    s.async = true;
                    s.setAttribute("data-swiper-js", "1");
                    s.onload = () => resolve();
                    s.onerror = (e) => reject(new Error("Failed to load Swiper"));
                    document.head.appendChild(s);
                } else {
                    const existing = document.querySelector('script[data-swiper-js]');
                    existing.addEventListener("load", () => resolve());
                    existing.addEventListener("error", () => reject(new Error("Failed to load Swiper")));
                }
            });
        }

        let swiperInstance = null;
        let observer = null;
        let resizeObserver = null;
        let currentMode = "none";
        let storedNodes = null;

        function computeTotalWidthByFormula(count) {
            if (count <= 0) return 0;
            return count * 90 + 10 * (count - 1) + 100;
        }

        function buildSliderFromGallery(gallery) {
            const items = Array.from(gallery.querySelectorAll(".jdgm-gallery__thumbnail-link"));
            if (!items.length) return null;

            storedNodes = items.slice();

            const swiperContainer = document.createElement("div");
            swiperContainer.className = "swiper jdgm-swiper";

            const wrapper = document.createElement("div");
            wrapper.className = "swiper-wrapper";

            items.forEach(item => {
                const slide = document.createElement("div");
                slide.className = "swiper-slide";
                slide.style.width = "auto";
                slide.appendChild(item);
                wrapper.appendChild(slide);
            });

            swiperContainer.appendChild(wrapper);

            const nextBtn = document.createElement("div");
            nextBtn.className = "swiper-button-next jdgm-swiper-next";

            const prevBtn = document.createElement("div");
            prevBtn.className = "swiper-button-prev jdgm-swiper-prev";

            swiperContainer.appendChild(prevBtn);
            swiperContainer.appendChild(nextBtn);

            gallery.innerHTML = "";
            gallery.appendChild(swiperContainer);

            return { swiperContainer, wrapper };
        }

        function restoreGalleryFromStored(gallery) {
            if (!storedNodes) return;
            gallery.innerHTML = "";
            storedNodes.forEach(node => gallery.appendChild(node));
            storedNodes = null;
        }

        async function evaluateAndToggle(gallery) {
            if (!gallery) return;

            const items = gallery.querySelectorAll(".jdgm-gallery__thumbnail-link");
            const count = items.length;
            if (count === 0) return;

            const formulaWidth = computeTotalWidthByFormula(count);
            const screenWidth = window.innerWidth;

            const realScrollWidth = gallery.scrollWidth || 0;
            const shouldBeSlider = formulaWidth > screenWidth || realScrollWidth > gallery.clientWidth;

            if (shouldBeSlider && currentMode !== "slider") {
                try {
                    await ensureSwiperLoaded();
                } catch (e) {
                    console.error("Failed to load Swiper:", e);
                    return;
                }

                const built = buildSliderFromGallery(gallery);
                if (!built) return;

                swiperInstance = new Swiper(".jdgm-swiper", {
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    freeMode: true,
                    mousewheel: true,
                    watchOverflow: true,

                    navigation: {
                        nextEl: ".jdgm-swiper-next",
                        prevEl: ".jdgm-swiper-prev",
                    },
                });


                currentMode = "slider";
                attachResizeObserver(gallery);
            } else if (!shouldBeSlider && currentMode === "slider") {
                if (swiperInstance) {
                    try {
                        swiperInstance.destroy(true, true);
                    } catch (e) {
                        console.warn("Swiper destroy error", e);
                    }
                    swiperInstance = null;
                }
                restoreGalleryFromStored(gallery);
                currentMode = "none";
                detachResizeObserver();
            } else {
                currentMode = shouldBeSlider ? "slider" : "none";
            }
        }

        function attachResizeObserver(gallery) {
            if (resizeObserver) return;
            resizeObserver = new ResizeObserver(() => {
                window.requestAnimationFrame(() => evaluateAndToggle(gallery));
            });
            resizeObserver.observe(document.documentElement);
            resizeObserver.observe(gallery);
            window.addEventListener("resize", handleWindowResize);
        }

        function detachResizeObserver() {
            if (!resizeObserver) return;
            resizeObserver.disconnect();
            resizeObserver = null;
            window.removeEventListener("resize", handleWindowResize);
        }

        function handleWindowResize() {
            if (handleWindowResize._timer) cancelAnimationFrame(handleWindowResize._timer);
            handleWindowResize._timer = requestAnimationFrame(() => {
                const gallery = document.querySelector(".jdgm-gallery");
                if (gallery) evaluateAndToggle(gallery);
            });
        }

        function startObserver() {
            if (observer) return;
            observer = new MutationObserver((mutations, obs) => {
                const gallery = document.querySelector(".jdgm-gallery");
                if (gallery) {
                    evaluateAndToggle(gallery);
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }

        if (document.readyState === "complete" || document.readyState === "interactive") {
            startObserver();
            const g = document.querySelector(".jdgm-gallery");
            if (g) evaluateAndToggle(g);
        } else {
            document.addEventListener("DOMContentLoaded", () => {
                startObserver();
                const g = document.querySelector(".jdgm-gallery");
                if (g) evaluateAndToggle(g);
            });
        }
    })();

    //7. Yellow button remove when the cart drawer page loaded

    const cart_drawer = document.querySelector("cart-drawer");
    const yellow_review_button = document.querySelector(".jdgm-revs-tab-btn");

    const A = document.querySelectorAll("cart-drawer");
    const B = document.querySelectorAll(".jdgm-revs-tab-btn");
    console.log(A);
    console.log(B);

    const observer = new MutationObserver(() => {

        if (!cart_drawer || !yellow_review_button) return;

        if (cart_drawer.classList.contains("active") && cart_drawer.classList.contains("animate")) {
            yellow_review_button.style.display = "none";
        } else {
            yellow_review_button.style.display = "revert";
        }
    });

    observer.observe(cart_drawer, { attributes: true, attributeFilter: ['class'] });
});